module.exports = __webpack_public_path__ + "static/media/P2-Tip-Solution-Blue.e90de207.svg";